import { useEffect } from 'react';
import { useVimOsContext } from './useVimOsContext';

export const useMicrophoneBadge = (isActive: boolean) => {
  const vimOS = useVimOsContext();

  useEffect(() => {
    try {
      if (isActive) {
        vimOS?.hub?.microphoneBadge?.show();
      } else {
        vimOS?.hub?.microphoneBadge?.hide();
      }
    } catch (e) {
      console.error('Failed to update microphone badge', e);
    }

    return () => {
      try {
        vimOS?.hub?.microphoneBadge?.hide();
      } catch (e) {
        // silent cleanup
      }
    };
  }, [isActive, vimOS]);
};
